<template lang="pug">
v-autocomplete(
  dense,
  v-model="dataProduct",
  :disabled="disabled",
  :readonly="readonly",
  :label="label",
  :rules="rules",
  :items="listProduct",
  item-text="productDescription",
  item-value="productId",
  @change="onSelect",
  :required="required"
)
</template>
<script>
export default {
  name: "FSelectProduct",
  props: [
    "value",
    "disabled",
    "readonly",
    "label",
    "rules",
    "required",
    "group",
    "auto",
    "featureInq",
    "allOption",
  ],
  data() {
    return {
      dataProduct: {},
      listData: [],
      productGroup: null,
      autoTransaction: false,
      featureInquiry: false,
    };
  },
  mounted() {
    this.doLoad();
    this.doInit(this.value);
  },
  watch: {
    value(val) {
      this.doInit(val);
    },
    group(val) {
      this.productGroup = val || "";
    },
    auto(val) {
      this.autoTransaction = val || false;
    },
    featureInq(val) {
      this.featureInquiry = val || false;
    },
    listProduct(val) {
      this.dataProduct = val
        ? val.length > 0
          ? val[0].productId
          : null
        : null;
      this.onSelect();
    },
  },
  computed: {
    listProduct() {
      if (this.productGroup) {
        return this.listData
          .filter((filter) => {
            return this.productGroup.split(",").includes(filter.productGroup);
          })
          .sort((a, b) =>
            a.productDescription > b.productDescription ? 1 : -1
          );
      } else if (this.autoTransaction) {
        return this.listData
          .filter((filter) => filter.autoTransaction === true)
          .sort((a, b) =>
            a.productDescription > b.productDescription ? 1 : -1
          );
      } else if (this.featureInquiry) {
        return this.listData
          .filter((filter) => filter.featureInquiry === true)
          .sort((a, b) =>
            a.productDescription > b.productDescription ? 1 : -1
          );
      } else {
        return this.listData.sort((a, b) =>
          a.productDescription > b.productDescription ? 1 : -1
        );
      }
    },
  },
  methods: {
    doInit(values) {
      this.dataProduct = values ? values : null;
      this.productGroup = this.group ? this.group : null;
      this.autoTransaction = this.auto ? this.auto : false;
      this.featureInquiry = this.featureInq ? this.featureInq : false;
    },
    doLoad() {
      this.$http.get("/api/parameter/product").then((success) => {
        this.listData = success.data;
        if (this.allOption === true) {
          this.listData.unshift({
            productId: "ALL",
            productDescription: "-- SEMUA --",
          });
        }
      });
    },
    onSelect() {
      this.$emit("input", this.dataProduct);
      this.$emit("select", this.dataProduct);
      this.$emit("product", this.valueData());
    },
    valueData() {
      let result = null;
      this.listData.map((element) => {
        if (this.dataProduct === element.productId) {
          result = element;
        }
      });
      return result;
    },
  },
};
</script>